__turbopack_context__.v({
  "widget": "DonationWidgetBlock-module-scss-module__45Bu6G__widget",
  "wrapper": "DonationWidgetBlock-module-scss-module__45Bu6G__wrapper",
});
